import React from 'react';
import { Field } from '../../ui';

interface ShippingTermsProps {
  vatType: string;
  vatNumber: string;
  onVatTypeChange: (value: string) => void;
  onVatNumberChange: (value: string) => void;
}

const ShippingTerms: React.FC<ShippingTermsProps> = ({
  vatType,
  vatNumber,
  onVatTypeChange,
  onVatNumberChange,
}) => {
  return (
    <div>
      <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 12 }}>Shipping Terms</h3>

      <div style={{ marginBottom: 16 }}>
        <Field label="Duties and taxes paid by">
          <select
            value="ddu"
            disabled
            style={{
              width: '100%',
              padding: '8px 12px',
              border: '1px solid var(--line)',
              borderRadius: 6,
              background: 'var(--bg-tint)',
              fontSize: 13,
              color: 'var(--ink-2)',
            }}
          >
            <option value="ddu">Duties and taxes are paid by the recipient DDU</option>
          </select>
        </Field>
        <p style={{ fontSize: 11, color: 'var(--ink-3)', marginTop: 4 }}>
          *Delivered Duty Unpaid (DDU) is an international trade term meaning the seller is responsible
          for ensuring goods arrive safely to a destination; the buyer is responsible for import duties
        </p>
      </div>
    </div>
  );
};

export default ShippingTerms;
